module.exports = __webpack_public_path__ + "img/delivery-boys-fill.5c44a72f.svg";